import React, { useState, useEffect } from 'react';
import '../pages-styles/TermsAndConditions.css';

function TermsAndConditions() {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTermsAndConditions = async () => {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL || 'https://admin.magbityagencyltd.com/api';
        const response = await fetch(`${apiUrl}/terms-and-conditions/terms/`);
        
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        
        const data = await response.json();
        setContent(data);
        setError(null);
      } catch (err) {
        console.error('Error fetching Terms and Conditions:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTermsAndConditions();
  }, []);

  if (loading) {
    return <div className="terms-container"><p>Loading Terms and Conditions...</p></div>;
  }

  if (error) {
    return (
      <div className="terms-container">
        <p className="error-message">Error loading Terms and Conditions: {error}</p>
      </div>
    );
  }

  // Parse the content if it's a string with HTML-like formatting
  const renderContent = (htmlContent) => {
    return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
  };

  return (
    <div className="terms-container">
      <div className="terms-content">
        <h1>{content?.title || 'Terms and Conditions'}</h1>
        {content?.last_updated && (
          <p className="last-updated">Last updated: {new Date(content.last_updated).toLocaleDateString()}</p>
        )}
        
        {content?.content && renderContent(content.content)}
      </div>
    </div>
  );
}

export default TermsAndConditions;
